
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12072',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12072",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.460",
  "dashboard-client-types": "static-1.342",
  "data-fetching-client": "static-1.9623",
  "foundations-components": "static-1.7826",
  "foundations-components-legacy": "static-1.851",
  "foundations-theming": "static-1.4365",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.81",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7964",
  "hub-http-shared-msw-handlers": "static-1.9836",
  "hubspot-dlb": "static-2.1832",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11410",
  "I18n": "static-7.1610",
  "jasmine-runner": "static-1.6418",
  "marketplace-storefront-base": "static-1.12133",
  "quartz": "static-1.6955",
  "react-dlb": "static-1.77",
  "react-rhumb": "static-1.16614",
  "reactive-variable-buffer-atom": "static-1.2808",
  "reporting-testing-lib": "static-1.9217",
  "settings-ui-lib": "static-1.12470",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7033",
  "ui-addon-i18n": "static-1.11099",
  "ui-addon-react-router-dom": "static-1.9494",
  "unified-auth": "static-1.424",
  "unified-auth-core-lib": "static-1.705",
  "usage-tracker": "static-1.7287",
  "usage-tracker-core": "static-1.7137",
  "customer-data-property-utils": "static-1.8032",
  "hub-http": "static-1.6170",
  "integrations-lib": "static-1.15941",
  "marketplace-ui-common": "static-1.19506",
  "property-management-iframe": "static-1.12974",
  "quartz-config": "static-1.733",
  "quartz-core": "static-1.6174",
  "quartz-routing": "static-1.385",
  "quick-fetch": "static-1.3873",
  "react": "static-7.184",
  "rpc-client-utils": "static-1.4599",
  "ts-schema": "static-1.4034",
  "ui-universal-auth": "static-1.8910",
  "UIComponents": "static-3.8357",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3360",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3232",
  "quartz-webpack": "static-1.3179",
  "bend-plugin-quartz-routing": "static-1.33",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4095",
  "floating-ui": "static-1.55",
  "foundations-assets": "static-1.4805",
  "foundations-theming-specialty": "static-1.2081",
  "framer-motion": "static-1.71",
  "hs-story-utils": "static-1.9377",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.9",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5300",
  "react-virtualized": "static-2.98",
  "StyleGuideUI": "static-3.486",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1657",
  "ui-fonts": "static-1.672",
  "ui-images": "static-2.1138",
  "bend-plugin-foundations-theming": "static-1.2848",
  "foundations-theming-base": "static-1.3350",
  "stylex": "static-1.32",
  "HeadJS": "static-2.740",
  "hs-test-utils-bend-plugin": "static-1.3075",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4273",
  "ai-components-ui-library": "static-1.8794",
  "ai-rendering-library": "static-1.9900",
  "chirp-fetch": "static-1.1834",
  "connections-embed-lib": "static-1.897",
  "copilot-toolkit": "static-1.10969",
  "feedback-loader": "static-1.29197",
  "laboratory-lib": "static-3.7107",
  "marketplace-embed": "static-1.21918",
  "marketplace-ui-details": "static-1.9402",
  "marketplace-ui-reviews": "static-1.19462",
  "marketplace-ui-tracking": "static-1.13677",
  "sanitize-text": "static-1.8092",
  "ui-addon-video-player": "static-1.8647",
  "usage-tracker-multi": "static-1.5701",
  "usage-tracker-session-replay": "static-1.4973",
  "wootric-nps": "static-1.6933",
  "quartz-head": "static-1.620",
  "web-vitals": "static-1.4",
  "apollo-link-hub-http": "static-2.4597",
  "immer": "static-1.33",
  "immerable": "static-1.4102",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2463",
  "reporting-data": "static-1.67284",
  "cssUtils": "static-1.778",
  "flux-actions": "static-1.330",
  "HubStyle": "static-2.11718",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10159",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10320",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7277",
  "icons": "static-2.643",
  "marketplace-ui-apps-core": "static-1.18039",
  "storybook-react": "static-1.32",
  "trellis-story-utils": "static-1.4464",
  "foundations-components-test-utils": "static-1.5309",
  "quartz-i18n": "static-1.630",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.73",
  "microsoft-drive-integration-lib": "static-1.185",
  "fsm": "static-1.3681",
  "customer-data-objects": "static-1.7610",
  "property-translator": "static-1.5351",
  "hs-locale-management": "static-1.40",
  "frontend-preferences-client": "static-1.7876",
  "hs-promise-utils": "static-1.5542",
  "hubspot-apollo-client": "static-1.4825",
  "integrations-error-boundary-lib": "static-1.13356",
  "integrations-tracking-lib": "static-1.5547",
  "native-integrations-shared-strings": "static-1.7732",
  "reselect": "static-2.16",
  "sanitize": "static-1.4421",
  "superstore": "static-1.4715",
  "ui-shepherd-react": "static-3.10097",
  "ai-settings-ui-library": "static-1.7798",
  "hub-http-janus": "static-1.826",
  "hubspotter-http": "static-1.4608",
  "immutable-less": "static-1.4598",
  "marketplace-ui-client-types": "static-1.16913",
  "nav-meta": "static-1.29475",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10194",
  "ui-addon-upgrades": "static-9.17910",
  "inbound-db-properties-service-client": "static-1.3797",
  "property-management-common": "static-1.5262",
  "ui-addon-iframeable": "static-1.9001",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.630",
  "quartz-test": "static-1.630",
  "quartz-tracking": "static-1.334",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.9",
  "bender-build-tools": "static-1.3123",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21022",
  "ContentUtils": "static-1.68200",
  "customer-data-objects-ui-components": "static-1.12973",
  "sassPrefix": "static-1.155",
  "avatar-components": "static-1.2446",
  "customer-data-filters-ui": "static-1.39558",
  "customer-data-reference-ui-components": "static-1.13107",
  "embedded-academy-lib": "static-1.14145",
  "ExportDialog": "static-6.10342",
  "highlight.js": "static-1.78",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41149",
  "reporting-snowflake": "static-1.55902",
  "reporting-ui-components": "static-2.64555",
  "reporting-visualizations": "static-1.59360",
  "ui-addon-teams": "static-1.21476",
  "magpie-lib": "static-1.5526",
  "navigation-components": "static-1.17838",
  "magpie-types": "static-1.4986",
  "simple-logging-lib": "static-1.2998",
  "ai-studio-lib": "static-1.11436",
  "app-governance-lib": "static-1.1366",
  "developer-experience-shared-components": "static-1.10457",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7943",
  "ui-product-approvals": "static-1.27981",
  "ui-tool-access": "static-1.10098",
  "usage-based-billing-components-lib": "static-1.8606",
  "usage-tracker-anonymous": "static-1.5704",
  "usage-tracker-public": "static-1.7098",
  "amplitude-session-replay-browser": "static-1.59",
  "inbound-db-meta-service-client": "static-1.3547",
  "persist-promise": "static-1.3656",
  "reference-resolvers": "static-1.8119",
  "ui-extensibility-client-types": "static-1.3878",
  "hubspot-apollo-cache": "static-1.284",
  "universal-page-editor-lib": "static-1.2961",
  "final-form": "static-1.69",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2616",
  "merchandise-lib": "static-1.262",
  "atom": "static-1.5021",
  "purchase-motions-components": "static-1.5786",
  "salesImages": "static-1.524",
  "batch-promise": "static-1.1499",
  "crm-component-utils": "static-1.38930",
  "crm-properties-common-lib": "static-1.5825",
  "customer-data-properties": "static-1.51355",
  "framework-data-schema-resolvers": "static-1.6827",
  "property-value-citations": "static-1.1969",
  "reference-resolvers-lite": "static-1.8043",
  "navigation-messaging": "static-1.7165",
  "hubspotter-http-shared-msw-handlers": "static-1.9834",
  "cms-field-types": "static-1.4760",
  "content-icons-ui": "static-1.2211",
  "customer-data-ui-utilities": "static-1.9775",
  "conversations-skeleton-state": "static-1.7197",
  "crm-message-bus": "static-1.42836",
  "customer-data-filters-ui-msw-helpers": "static-1.21993",
  "FormUrlGenerator": "static-2.4668",
  "framework-builder-read-service-client": "static-1.3966",
  "framework-data-schema-quick-fetch": "static-1.6732",
  "multi-account-reference-resolvers": "static-1.928",
  "onboarding-tours": "static-1.16495",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13507",
  "academy-common-lib": "static-1.13605",
  "content-assistance-lib": "static-1.7669",
  "dashboard-lib": "static-1.81310",
  "file-manager-components": "static-1.23461",
  "getting-started-shared-tasks": "static-1.18340",
  "hubspot-prosemirror": "static-1.18077",
  "hubspot-prosemirror-plugins": "static-1.18069",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19735",
  "share-with-third-party-component-lib": "static-1.8646",
  "ui-addon-draggable": "static-3.4718",
  "ui-asset-management-lib": "static-1.10952",
  "ui-business-units-lib": "static-1.8996",
  "user-context": "static-1.5050",
  "growth-payments-core": "static-1.25204",
  "reporting-plugins": "static-1.10202",
  "reporting-reports": "static-1.66962",
  "idb-keyval": "static-1.43",
  "reactive-lib": "static-1.670",
  "nest": "static-1.174",
  "codemirror": "static-5.94",
  "react-codemirror": "static-1.10572",
  "framework-listing-lib": "static-2.28522",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30567",
  "apps-service-types": "static-1.3826",
  "oauth-service-types": "static-1.4198",
  "onboarding-scopes": "static-1.6411",
  "onboarding-tours-client": "static-1.4709",
  "platform-infra-nav-components": "static-1.7629",
  "subscription-experience-data-types": "static-1.14837",
  "crm-record-cards-service-types": "static-1.3567",
  "location-customization-utils-lib": "static-1.9079",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5789",
  "signup-constants": "static-1.18740",
  "signup-ui-url-generator": "static-2.7987",
  "trials-service-types": "static-1.3852",
  "card-properties-lib": "static-1.44007",
  "commerce-subscription-lib": "static-1.36939",
  "crm-actions": "static-1.6267",
  "crm-cards-sdk": "static-1.43416",
  "customer-data-properties-shared-msw-handlers": "static-1.9163",
  "customer-data-tracking": "static-1.6834",
  "hs-resources": "static-1.93",
  "pulse": "static-1.504",
  "calling-global-api": "static-1.64315",
  "calling-internal-common": "static-1.31250",
  "calling-lifecycle-internal": "static-1.65697",
  "calling-lifecycle-messages": "static-1.57991",
  "commerce-products-lib": "static-1.9323",
  "conditional-properties-service-client": "static-1.3753",
  "crm-links": "static-1.6230",
  "external-options-client-types": "static-1.4115",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4180",
  "meetings-icalendar-utils-lib": "static-1.580",
  "multi-currency-client-types": "static-1.3648",
  "object-builder-ui-client": "static-1.48551",
  "pipeline-validation-client-types": "static-1.3922",
  "smart-property-lib": "static-1.6665",
  "tiered-pricing": "static-1.1094",
  "ui-addon-form-validation": "static-1.10937",
  "crm-pipelines-api-client-types": "static-1.4099",
  "react-dnd-compat": "static-1.4569",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5342",
  "growth-onboarding-confetti": "static-1.3016",
  "growth-onboarding-next-action-utils": "static-1.1752",
  "onboarding-tours-utils": "static-1.561",
  "ui-shepherd-tracker": "static-1.7478",
  "academy-service-client": "static-1.3631",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.38960",
  "FileManagerLib": "static-1.39101",
  "video-embed": "static-1.35581",
  "zustand": "static-1.72",
  "ui-coaching-tips": "static-1.28389",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8322",
  "video-components-external": "static-1.11089",
  "video-data-lib": "static-1.34747",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23374",
  "ui-addon-emoji-picker": "static-1.9836",
  "EmailSignatureEditor": "static-1.24254",
  "viral-links-lib": "static-1.7001",
  "data-token-picker": "static-1.16308",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.174",
  "timezone-utils": "static-2.5193",
  "getting-started-shared-tasks-store": "static-1.17458",
  "campaign-roi-lib": "static-1.8916",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7274",
  "customer-data-views-management": "static-1.25346",
  "framework-data-table": "static-2.11792",
  "marketing-platform-lib": "static-1.6800",
  "nudge-client-utils": "static-1.2439",
  "nudge-custom-ui-functions": "static-1.927",
  "app-users-service-client": "static-1.5534",
  "app-users-service-types": "static-1.4942",
  "mini-checkout-client": "static-1.26665",
  "onboarding-utils": "static-1.5300",
  "permissions-shared-i18n-strings-fe": "static-1.2024",
  "ui-coaching-tips-shared-config": "static-1.28374",
  "edison-service-client-types": "static-1.335",
  "crm_data": "static-4.91778",
  "customer-data-sidebar": "static-2.45842",
  "enrichment-properties-lib": "static-1.15783",
  "commerce-billing-lib": "static-1.18904",
  "commerce-shared-components-lib": "static-1.18364",
  "commerce-tools-ui-lib": "static-1.10224",
  "crm-fe-perf": "static-1.22852",
  "bend-plugin-pulse": "static-1.7",
  "directed-graph": "static-1.884",
  "event-emitter": "static-1.897",
  "fast-json-patch": "static-1.62",
  "calling-error-reporting": "static-1.31256",
  "shared-worker-versioning": "static-1.10986",
  "calling-usage-tracker": "static-1.6491",
  "voice-sms-access-library": "static-1.760",
  "commerce-permissions": "static-1.714",
  "products-iframe-lib": "static-1.7766",
  "products-ui-components-shared-msw-handlers": "static-1.10218",
  "data-agent-kit": "static-1.108",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9919",
  "policy-lib": "static-1.6721",
  "react-tinymce": "static-1.55084",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9982",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54210",
  "tinymce-plugins": "static-1.57324",
  "tinymce-themes": "static-1.56180",
  "onboarding-data-sync-lib": "static-1.1871",
  "growth-onboarding-next-action-components": "static-1.1780",
  "user-context-client": "static-1.4559",
  "audio-components": "static-1.5834",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36612",
  "urlinator": "static-1.4480",
  "video-components": "static-1.13092",
  "outpost": "static-1.4138",
  "growth-onboarding-feedback-components": "static-1.6532",
  "content-media-composition-data-lib": "static-1.12063",
  "content-media-compositions": "static-2.16070",
  "media-bridge-lib": "static-1.18831",
  "commerce-tours-lib": "static-1.5993",
  "growth-onboarding-reliability": "static-1.5030",
  "sales-checkout-service-client": "static-1.3588",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21574",
  "sales-email-signature-service-client": "static-1.3792",
  "ts-utils-lib": "static-1.122",
  "crm-export-dialog": "static-1.6247",
  "crm-index-associations-lib": "static-1.6387",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1817",
  "tanstack-virtual": "static-1.29",
  "nudge-custom-function-registry": "static-1.2196",
  "nudge-renderer-utils": "static-1.2515",
  "whisper-core-api": "static-1.6447",
  "InboxConnectUtils": "static-4.14645",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5381",
  "settings-content-modals": "static-1.45917",
  "crm_universal": "static-1.21911",
  "customer-data-email": "static-1.17937",
  "card-payment-highlight-lib": "static-1.37006",
  "card-subscription-highlight-lib": "static-1.39362",
  "commerce-contract-lib": "static-1.11836",
  "invoices-highlight-card-lib": "static-1.54527",
  "orders-highlight-card-lib": "static-1.21304",
  "products-highlight-card-lib": "static-1.17607",
  "quotes-highlight-card-lib": "static-1.71791",
  "crm-source-interpretation-lib": "static-1.5286",
  "utility-belt": "static-1.2486",
  "payments-enrollment-embed-lib": "static-1.22516",
  "stripe-embedded-components": "static-1.7405",
  "customer-data-rte": "static-1.32848",
  "cv-backend-services": "static-1.1551",
  "growth-onboarding-empty-states": "static-1.5615",
  "payments-post-enroll-local-storage-lib": "static-1.5058",
  "qrcode-generator": "static-1.68",
  "quotes-client-types": "static-1.37881",
  "calling-orchestration-schema": "static-1.35537",
  "sales-views-client-types": "static-1.4213",
  "hub-http-contrib": "static-1.2989",
  "interframe": "static-3.4710",
  "tinymce-data": "static-1.40295",
  "ui-addon-sales-email": "static-1.5159",
  "layout-dnd-components": "static-1.12338",
  "layout-dnd-utils": "static-1.11313",
  "ui-brand-identity-lib": "static-1.14991",
  "NamespacedHubStyle": "static-2.9019",
  "social-insights-client-types": "static-1.21929",
  "js-cookie": "static-1.18",
  "deal-intel-utils": "static-1.1821",
  "checkout-sdk": "static-3.23508",
  "checkout-service-types": "static-1.3783",
  "company-details-components": "static-1.6145",
  "payment-method-components": "static-1.6861",
  "pricing-pages-ui-components": "static-1.13606",
  "quote-checkout-service-types": "static-1.3428",
  "upgrade-catalog-service-types": "static-1.3473",
  "access-control-lib": "static-1.10386",
  "EmailComponents": "static-1.54610",
  "EmailData": "static-1.53287",
  "redux-less": "static-2.9432",
  "sequences-lib": "static-1.7945",
  "ui-gdpr-components": "static-1.10296",
  "products-ui-components": "static-1.39842",
  "accounting-integrations-ui-components": "static-1.6973",
  "invoices-ui-lib": "static-1.54543",
  "commerce-products-api": "static-1.2207",
  "invoices-iframe-lib": "static-1.56601",
  "quotes-modal-lib": "static-1.102469",
  "quotes-ui-lib": "static-1.80512",
  "stripe-connect-js": "static-1.67",
  "draft-content-plugins": "static-1.28116",
  "ContentData": "static-1.68275",
  "layout-data-lib": "static-1.9638",
  "hub-http-rxjs": "static-1.792",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3881",
  "billing-payments-client-types": "static-1.3939",
  "react-performance-metrics-lib": "static-1.507",
  "account-and-billing-fintech-outages": "static-3.18491",
  "pricing-pages-api": "static-1.13471",
  "ContentComponents": "static-2.71156",
  "marketing-contacts-lib": "static-1.9770",
  "marketing-email-service-types": "static-1.1883",
  "messaging-editing-lib": "static-1.46099",
  "messaging-usage-based-billing-components-lib": "static-1.961",
  "automation-ui-source-apps": "static-1.18704",
  "automation-ui-types": "static-1.19622",
  "messaging-types-lib": "static-1.45836",
  "onboarding-settings-client": "static-1.4451",
  "sequences-client-types-lib": "static-1.7802",
  "commerce-tax-lib": "static-1.471",
  "property-description-translator": "static-1.3796",
  "commerce-analytics-service-client": "static-1.3576",
  "totals-ui-components": "static-1.23425",
  "SalesContentIndexUI": "static-3.9162",
  "advanced-menus-core": "static-1.15042",
  "advanced-menus-lib": "static-1.11996",
  "ui-memberships-settings-lib": "static-1.33893",
  "segments-query-core": "static-1.1363",
  "demographics-service-types": "static-1.1601",
  "eligibility-engine-service-types": "static-1.3133",
  "automation-ui-ubb": "static-1.5538",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7288",
  "data-token-views": "static-1.16289",
  "forms-utils-lib": "static-1.12475",
  "payments-embed-points-lib": "static-1.12916",
  "simple-menus-core": "static-1.15041",
  "simple-menus-lib": "static-1.16558",
  "ui-addon-draggable-compat": "static-2.4203",
  "videoconference-integration-components": "static-1.6740",
  "automation-applications-service-types": "static-1.3457",
  "automation-platform-service-types": "static-1.2565",
  "ContentEditorUI": "static-2.76958",
  "short-messages-app-service-client": "static-1.3930",
  "web-interactives-components": "static-1.13665",
  "web-interactives-data": "static-1.13666",
  "messaging-shared-utils-lib": "static-1.410",
  "messaging-user-info-utils-lib": "static-1.580",
  "email-portal-health-service-types": "static-1.925",
  "commerce-totals-service-types": "static-1.3775",
  "FireAlarmUi": "static-1.4470",
  "sales-templates-service-types-lib": "static-1.4124",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21558",
  "automation-ui-usage-tracking": "static-1.21021",
  "data-studio-ubb": "static-1.2551",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26865",
  "collaboration-sidebar": "static-1.57628",
  "content-management-data-lib": "static-1.5314",
  "copilot-plugins": "static-1.10942",
  "cta-picker": "static-1.36253",
  "customer-agent-discovery-components-lib": "static-1.2922",
  "editor-components": "static-1.13156",
  "editor-iframe-lib": "static-1.8328",
  "error-messaging-js": "static-1.5140",
  "FormsCommonComponents": "static-1.85683",
  "pictos": "static-7.183",
  "react-transition-group": "static-2.64",
  "redux-request-state": "static-1.10595",
  "SharedLegalStrings": "static-1.1696",
  "smart-content-core": "static-1.42280",
  "smart-content-lib": "static-1.42933",
  "social-composer-lib": "static-1.58851",
  "structured-content-lib": "static-1.25040",
  "theme-previewer-lib": "static-1.53098",
  "tinymce-copilot": "static-1.16278",
  "xray-recommendation-lib": "static-1.7827",
  "automation-ui-routing": "static-1.20979",
  "sql-reporting-client-types": "static-1.5588",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42046",
  "campaigns-utils-lib": "static-1.3113",
  "reporting-enablement": "static-1.22711",
  "chatspot-widget-iframe": "static-1.21013",
  "collaboration-sidebar-common": "static-1.2425",
  "forms-ai-lib": "static-1.4232",
  "codemirror-dlb": "static-1.58517",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6378",
  "report-customization-components": "static-1.12987",
  "data-quality-ui-library": "static-1.12749",
  "html-to-image": "static-1.53",
  "reporting-filters": "static-1.171",
  "reporting-insights-lib": "static-1.1567"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12072",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.460",
  "dashboard-client-types": "/dashboard-client-types/static-1.342",
  "data-fetching-client": "/data-fetching-client/static-1.9623",
  "foundations-components": "/foundations-components/static-1.7826",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.851",
  "foundations-theming": "/foundations-theming/static-1.4365",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.81",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7964",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9836",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11410",
  "I18n": "/I18n/static-7.1610",
  "jasmine-runner": "/jasmine-runner/static-1.6418",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12133",
  "quartz": "/quartz/static-1.6955",
  "react-dlb": "/react-dlb/static-1.77",
  "react-rhumb": "/react-rhumb/static-1.16614",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2808",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9217",
  "settings-ui-lib": "/settings-ui-lib/static-1.12470",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7033",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11099",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9494",
  "unified-auth": "/unified-auth/static-1.424",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.705",
  "usage-tracker": "/usage-tracker/static-1.7287",
  "usage-tracker-core": "/usage-tracker-core/static-1.7137",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8032",
  "hub-http": "/hub-http/static-1.6170",
  "integrations-lib": "/integrations-lib/static-1.15941",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19506",
  "property-management-iframe": "/property-management-iframe/static-1.12974",
  "quartz-config": "/quartz-config/static-1.733",
  "quartz-core": "/quartz-core/static-1.6174",
  "quartz-routing": "/quartz-routing/static-1.385",
  "quick-fetch": "/quick-fetch/static-1.3873",
  "react": "/react/static-7.184",
  "rpc-client-utils": "/rpc-client-utils/static-1.4599",
  "ts-schema": "/ts-schema/static-1.4034",
  "ui-universal-auth": "/ui-universal-auth/static-1.8910",
  "UIComponents": "/UIComponents/static-3.8357",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3360",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3232",
  "quartz-webpack": "/quartz-webpack/static-1.3179",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.33",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4095",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4805",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2081",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-story-utils": "/hs-story-utils/static-1.9377",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5300",
  "react-virtualized": "/react-virtualized/static-2.98",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1657",
  "ui-fonts": "/ui-fonts/static-1.672",
  "ui-images": "/ui-images/static-2.1138",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2848",
  "foundations-theming-base": "/foundations-theming-base/static-1.3350",
  "stylex": "/stylex/static-1.32",
  "HeadJS": "/HeadJS/static-2.740",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3075",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4273",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8794",
  "ai-rendering-library": "/ai-rendering-library/static-1.9900",
  "chirp-fetch": "/chirp-fetch/static-1.1834",
  "connections-embed-lib": "/connections-embed-lib/static-1.897",
  "copilot-toolkit": "/copilot-toolkit/static-1.10969",
  "feedback-loader": "/feedback-loader/static-1.29197",
  "laboratory-lib": "/laboratory-lib/static-3.7107",
  "marketplace-embed": "/marketplace-embed/static-1.21918",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9402",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19462",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13677",
  "sanitize-text": "/sanitize-text/static-1.8092",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8647",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5701",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4973",
  "wootric-nps": "/wootric-nps/static-1.6933",
  "quartz-head": "/quartz-head/static-1.620",
  "web-vitals": "/web-vitals/static-1.4",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4597",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4102",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2463",
  "reporting-data": "/reporting-data/static-1.67284",
  "cssUtils": "/cssUtils/static-1.778",
  "flux-actions": "/flux-actions/static-1.330",
  "HubStyle": "/HubStyle/static-2.11718",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10159",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10320",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7277",
  "icons": "/icons/static-2.643",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18039",
  "storybook-react": "/storybook-react/static-1.32",
  "trellis-story-utils": "/trellis-story-utils/static-1.4464",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5309",
  "quartz-i18n": "/quartz-i18n/static-1.630",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.73",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.185",
  "fsm": "/fsm/static-1.3681",
  "customer-data-objects": "/customer-data-objects/static-1.7610",
  "property-translator": "/property-translator/static-1.5351",
  "hs-locale-management": "/hs-locale-management/static-1.40",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7876",
  "hs-promise-utils": "/hs-promise-utils/static-1.5542",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4825",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13356",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5547",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7732",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4421",
  "superstore": "/superstore/static-1.4715",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10097",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7798",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "hubspotter-http": "/hubspotter-http/static-1.4608",
  "immutable-less": "/immutable-less/static-1.4598",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16913",
  "nav-meta": "/nav-meta/static-1.29475",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10194",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17910",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3797",
  "property-management-common": "/property-management-common/static-1.5262",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9001",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.630",
  "quartz-test": "/quartz-test/static-1.630",
  "quartz-tracking": "/quartz-tracking/static-1.334",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.9",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21022",
  "ContentUtils": "/ContentUtils/static-1.68200",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12973",
  "sassPrefix": "/sassPrefix/static-1.155",
  "avatar-components": "/avatar-components/static-1.2446",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39558",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13107",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14145",
  "ExportDialog": "/ExportDialog/static-6.10342",
  "highlight.js": "/highlight.js/static-1.78",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41149",
  "reporting-snowflake": "/reporting-snowflake/static-1.55902",
  "reporting-ui-components": "/reporting-ui-components/static-2.64555",
  "reporting-visualizations": "/reporting-visualizations/static-1.59360",
  "ui-addon-teams": "/ui-addon-teams/static-1.21476",
  "magpie-lib": "/magpie-lib/static-1.5526",
  "navigation-components": "/navigation-components/static-1.17838",
  "magpie-types": "/magpie-types/static-1.4986",
  "simple-logging-lib": "/simple-logging-lib/static-1.2998",
  "ai-studio-lib": "/ai-studio-lib/static-1.11436",
  "app-governance-lib": "/app-governance-lib/static-1.1366",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10457",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7943",
  "ui-product-approvals": "/ui-product-approvals/static-1.27981",
  "ui-tool-access": "/ui-tool-access/static-1.10098",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8606",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5704",
  "usage-tracker-public": "/usage-tracker-public/static-1.7098",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3547",
  "persist-promise": "/persist-promise/static-1.3656",
  "reference-resolvers": "/reference-resolvers/static-1.8119",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3878",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.284",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2961",
  "final-form": "/final-form/static-1.69",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2616",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "atom": "/atom/static-1.5021",
  "purchase-motions-components": "/purchase-motions-components/static-1.5786",
  "salesImages": "/salesImages/static-1.524",
  "batch-promise": "/batch-promise/static-1.1499",
  "crm-component-utils": "/crm-component-utils/static-1.38930",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5825",
  "customer-data-properties": "/customer-data-properties/static-1.51355",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6827",
  "property-value-citations": "/property-value-citations/static-1.1969",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8043",
  "navigation-messaging": "/navigation-messaging/static-1.7165",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9834",
  "cms-field-types": "/cms-field-types/static-1.4760",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9775",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7197",
  "crm-message-bus": "/crm-message-bus/static-1.42836",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21993",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4668",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3966",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6732",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.928",
  "onboarding-tours": "/onboarding-tours/static-1.16495",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13507",
  "academy-common-lib": "/academy-common-lib/static-1.13605",
  "content-assistance-lib": "/content-assistance-lib/static-1.7669",
  "dashboard-lib": "/dashboard-lib/static-1.81310",
  "file-manager-components": "/file-manager-components/static-1.23461",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18340",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18077",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18069",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19735",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8646",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4718",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10952",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8996",
  "user-context": "/user-context/static-1.5050",
  "growth-payments-core": "/growth-payments-core/static-1.25204",
  "reporting-plugins": "/reporting-plugins/static-1.10202",
  "reporting-reports": "/reporting-reports/static-1.66962",
  "idb-keyval": "/idb-keyval/static-1.43",
  "reactive-lib": "/reactive-lib/static-1.670",
  "nest": "/nest/static-1.174",
  "codemirror": "/codemirror/static-5.94",
  "react-codemirror": "/react-codemirror/static-1.10572",
  "framework-listing-lib": "/framework-listing-lib/static-2.28522",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30567",
  "apps-service-types": "/apps-service-types/static-1.3826",
  "oauth-service-types": "/oauth-service-types/static-1.4198",
  "onboarding-scopes": "/onboarding-scopes/static-1.6411",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4709",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7629",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14837",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3567",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9079",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5789",
  "signup-constants": "/signup-constants/static-1.18740",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7987",
  "trials-service-types": "/trials-service-types/static-1.3852",
  "card-properties-lib": "/card-properties-lib/static-1.44007",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36939",
  "crm-actions": "/crm-actions/static-1.6267",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43416",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9163",
  "customer-data-tracking": "/customer-data-tracking/static-1.6834",
  "hs-resources": "/hs-resources/static-1.93",
  "pulse": "/pulse/static-1.504",
  "calling-global-api": "/calling-global-api/static-1.64315",
  "calling-internal-common": "/calling-internal-common/static-1.31250",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65697",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57991",
  "commerce-products-lib": "/commerce-products-lib/static-1.9323",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3753",
  "crm-links": "/crm-links/static-1.6230",
  "external-options-client-types": "/external-options-client-types/static-1.4115",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4180",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.580",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3648",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48551",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3922",
  "smart-property-lib": "/smart-property-lib/static-1.6665",
  "tiered-pricing": "/tiered-pricing/static-1.1094",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10937",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4099",
  "react-dnd-compat": "/react-dnd-compat/static-1.4569",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5342",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3016",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1752",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.561",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7478",
  "academy-service-client": "/academy-service-client/static-1.3631",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.38960",
  "FileManagerLib": "/FileManagerLib/static-1.39101",
  "video-embed": "/video-embed/static-1.35581",
  "zustand": "/zustand/static-1.72",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28389",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8322",
  "video-components-external": "/video-components-external/static-1.11089",
  "video-data-lib": "/video-data-lib/static-1.34747",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23374",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9836",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24254",
  "viral-links-lib": "/viral-links-lib/static-1.7001",
  "data-token-picker": "/data-token-picker/static-1.16308",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.174",
  "timezone-utils": "/timezone-utils/static-2.5193",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17458",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8916",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7274",
  "customer-data-views-management": "/customer-data-views-management/static-1.25346",
  "framework-data-table": "/framework-data-table/static-2.11792",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6800",
  "nudge-client-utils": "/nudge-client-utils/static-1.2439",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.927",
  "app-users-service-client": "/app-users-service-client/static-1.5534",
  "app-users-service-types": "/app-users-service-types/static-1.4942",
  "mini-checkout-client": "/mini-checkout-client/static-1.26665",
  "onboarding-utils": "/onboarding-utils/static-1.5300",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2024",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28374",
  "edison-service-client-types": "/edison-service-client-types/static-1.335",
  "crm_data": "/crm_data/static-4.91778",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45842",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15783",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18904",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18364",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10224",
  "crm-fe-perf": "/crm-fe-perf/static-1.22852",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.7",
  "directed-graph": "/directed-graph/static-1.884",
  "event-emitter": "/event-emitter/static-1.897",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "calling-error-reporting": "/calling-error-reporting/static-1.31256",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10986",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6491",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.760",
  "commerce-permissions": "/commerce-permissions/static-1.714",
  "products-iframe-lib": "/products-iframe-lib/static-1.7766",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10218",
  "data-agent-kit": "/data-agent-kit/static-1.108",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9919",
  "policy-lib": "/policy-lib/static-1.6721",
  "react-tinymce": "/react-tinymce/static-1.55084",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9982",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54210",
  "tinymce-plugins": "/tinymce-plugins/static-1.57324",
  "tinymce-themes": "/tinymce-themes/static-1.56180",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1871",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1780",
  "user-context-client": "/user-context-client/static-1.4559",
  "audio-components": "/audio-components/static-1.5834",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36612",
  "urlinator": "/urlinator/static-1.4480",
  "video-components": "/video-components/static-1.13092",
  "outpost": "/outpost/static-1.4138",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6532",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12063",
  "content-media-compositions": "/content-media-compositions/static-2.16070",
  "media-bridge-lib": "/media-bridge-lib/static-1.18831",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5993",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5030",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3588",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21574",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3792",
  "ts-utils-lib": "/ts-utils-lib/static-1.122",
  "crm-export-dialog": "/crm-export-dialog/static-1.6247",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6387",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1817",
  "tanstack-virtual": "/tanstack-virtual/static-1.29",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2196",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2515",
  "whisper-core-api": "/whisper-core-api/static-1.6447",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14645",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5381",
  "settings-content-modals": "/settings-content-modals/static-1.45917",
  "crm_universal": "/crm_universal/static-1.21911",
  "customer-data-email": "/customer-data-email/static-1.17937",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37006",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39362",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11836",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54527",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21304",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17607",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71791",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5286",
  "utility-belt": "/utility-belt/static-1.2486",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22516",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7405",
  "customer-data-rte": "/customer-data-rte/static-1.32848",
  "cv-backend-services": "/cv-backend-services/static-1.1551",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5615",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5058",
  "qrcode-generator": "/qrcode-generator/static-1.68",
  "quotes-client-types": "/quotes-client-types/static-1.37881",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35537",
  "sales-views-client-types": "/sales-views-client-types/static-1.4213",
  "hub-http-contrib": "/hub-http-contrib/static-1.2989",
  "interframe": "/interframe/static-3.4710",
  "tinymce-data": "/tinymce-data/static-1.40295",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5159",
  "layout-dnd-components": "/layout-dnd-components/static-1.12338",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11313",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14991",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9019",
  "social-insights-client-types": "/social-insights-client-types/static-1.21929",
  "js-cookie": "/js-cookie/static-1.18",
  "deal-intel-utils": "/deal-intel-utils/static-1.1821",
  "checkout-sdk": "/checkout-sdk/static-3.23508",
  "checkout-service-types": "/checkout-service-types/static-1.3783",
  "company-details-components": "/company-details-components/static-1.6145",
  "payment-method-components": "/payment-method-components/static-1.6861",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13606",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3428",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3473",
  "access-control-lib": "/access-control-lib/static-1.10386",
  "EmailComponents": "/EmailComponents/static-1.54610",
  "EmailData": "/EmailData/static-1.53287",
  "redux-less": "/redux-less/static-2.9432",
  "sequences-lib": "/sequences-lib/static-1.7945",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10296",
  "products-ui-components": "/products-ui-components/static-1.39842",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6973",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54543",
  "commerce-products-api": "/commerce-products-api/static-1.2207",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56601",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102469",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80512",
  "stripe-connect-js": "/stripe-connect-js/static-1.67",
  "draft-content-plugins": "/draft-content-plugins/static-1.28116",
  "ContentData": "/ContentData/static-1.68275",
  "layout-data-lib": "/layout-data-lib/static-1.9638",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.792",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3881",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3939",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.507",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18491",
  "pricing-pages-api": "/pricing-pages-api/static-1.13471",
  "ContentComponents": "/ContentComponents/static-2.71156",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9770",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1883",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46099",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.961",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18704",
  "automation-ui-types": "/automation-ui-types/static-1.19622",
  "messaging-types-lib": "/messaging-types-lib/static-1.45836",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4451",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7802",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.471",
  "property-description-translator": "/property-description-translator/static-1.3796",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3576",
  "totals-ui-components": "/totals-ui-components/static-1.23425",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9162",
  "advanced-menus-core": "/advanced-menus-core/static-1.15042",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11996",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33893",
  "segments-query-core": "/segments-query-core/static-1.1363",
  "demographics-service-types": "/demographics-service-types/static-1.1601",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3133",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5538",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7288",
  "data-token-views": "/data-token-views/static-1.16289",
  "forms-utils-lib": "/forms-utils-lib/static-1.12475",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12916",
  "simple-menus-core": "/simple-menus-core/static-1.15041",
  "simple-menus-lib": "/simple-menus-lib/static-1.16558",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4203",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6740",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3457",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2565",
  "ContentEditorUI": "/ContentEditorUI/static-2.76958",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3930",
  "web-interactives-components": "/web-interactives-components/static-1.13665",
  "web-interactives-data": "/web-interactives-data/static-1.13666",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.410",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.580",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.925",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3775",
  "FireAlarmUi": "/FireAlarmUi/static-1.4470",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4124",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21558",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21021",
  "data-studio-ubb": "/data-studio-ubb/static-1.2551",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26865",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57628",
  "content-management-data-lib": "/content-management-data-lib/static-1.5314",
  "copilot-plugins": "/copilot-plugins/static-1.10942",
  "cta-picker": "/cta-picker/static-1.36253",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2922",
  "editor-components": "/editor-components/static-1.13156",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8328",
  "error-messaging-js": "/error-messaging-js/static-1.5140",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85683",
  "pictos": "/pictos/static-7.183",
  "react-transition-group": "/react-transition-group/static-2.64",
  "redux-request-state": "/redux-request-state/static-1.10595",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1696",
  "smart-content-core": "/smart-content-core/static-1.42280",
  "smart-content-lib": "/smart-content-lib/static-1.42933",
  "social-composer-lib": "/social-composer-lib/static-1.58851",
  "structured-content-lib": "/structured-content-lib/static-1.25040",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53098",
  "tinymce-copilot": "/tinymce-copilot/static-1.16278",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7827",
  "automation-ui-routing": "/automation-ui-routing/static-1.20979",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5588",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42046",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3113",
  "reporting-enablement": "/reporting-enablement/static-1.22711",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21013",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2425",
  "forms-ai-lib": "/forms-ai-lib/static-1.4232",
  "codemirror-dlb": "/codemirror-dlb/static-1.58517",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6378",
  "report-customization-components": "/report-customization-components/static-1.12987",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12749",
  "html-to-image": "/html-to-image/static-1.53",
  "reporting-filters": "/reporting-filters/static-1.171",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1567"
}
};
